"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import PencilIcon from "@/components/utils/icons/PencilIcon";
import { createPortal } from "react-dom";
import UserPageHeaderEditPfp from "./UserPageHeaderEditPfp";
export default function UserPageHeaderPfpWrapper(t0) {
  const $ = _c(20);
  const {
    profile,
    canEdit,
    children
  } = t0;
  const [isEditPfpOpen, setIsEditPfpOpen] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsMounted(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[2] !== isEditPfpOpen) {
    t3 = () => {
      if (!isEditPfpOpen || typeof document === "undefined") {
        return;
      }
      const previousOverflow = document.body.style.overflow;
      const previousPaddingRight = document.body.style.paddingRight;
      const scrollbarGap = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = "hidden";
      if (scrollbarGap > 0) {
        document.body.style.paddingRight = `${scrollbarGap}px`;
      }
      return () => {
        document.body.style.overflow = previousOverflow;
        document.body.style.paddingRight = previousPaddingRight;
      };
    };
    t4 = [isEditPfpOpen];
    $[2] = isEditPfpOpen;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsEditPfpOpen(true);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = !canEdit;
  const t7 = canEdit ? "Edit profile picture" : "Profile picture";
  let t8;
  if ($[6] !== canEdit) {
    t8 = canEdit && <div className="tw-left-1 tw-right-1 tw-top-[4px] tw-bottom-[4px] edit-profile tw-bg-black/50 tw-absolute tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-transition tw-duration-300 tw-ease-out tw-rounded-lg"><div className="tw-absolute tw-bottom-2 tw-right-2"><PencilIcon /></div></div>;
    $[6] = canEdit;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== children || $[9] !== t6 || $[10] !== t7 || $[11] !== t8) {
    t9 = <button onClick={t5} disabled={t6} className="tw-group tw-bg-transparent tw-border-none tw-relative tw-p-1 tw-rounded-lg" aria-label={t7}>{children}{t8}</button>;
    $[8] = children;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== isEditPfpOpen || $[14] !== isMounted || $[15] !== profile) {
    t10 = isMounted && isEditPfpOpen && createPortal(<UserPageHeaderEditPfp profile={profile} onClose={() => setIsEditPfpOpen(false)} />, document.body);
    $[13] = isEditPfpOpen;
    $[14] = isMounted;
    $[15] = profile;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t9) {
    t11 = <div>{t9}{t10}</div>;
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
}